import axiosInstance from "../utils/axiosInstance";
import { Tag } from "../interfaces/tag.interface";

class TagsApi {
  getTags(type?: "series" | "cruise"): Promise<Tag[]> {
    const apiUrl = `/b2c2b/api/v1/tags?all=true${type ? `&type=${type}` : ""}`;

    return axiosInstance.get(apiUrl)
      .then(response => {
        const tags: Tag[] = (response.data?.data || []).map(({ id, attributes }) => ({
          id: String(attributes?.id ?? id),
          name: attributes?.name,
          description: attributes?.description,
          position: attributes?.position,
        }));

        return Promise.resolve(tags.sort((a, b) => (a.position ?? 0) - (b.position ?? 0)));
      });
  }
}

export default new TagsApi();
